<template>
  <div id="app" class="app-root">
    <layout-header></layout-header>
    <div class="app-container" :style="{ position: modal.action && !isDialogLoading ? 'relative' : 'relative' }">
      <div class="app-pages">
        <div class="app-background" :class="{ filter: !isMainPage, cover: isMainPage }" :style="needBackground ? { backgroundImage: 'url(' + require('./assets/images/main-background.jpg') + ')', backgroundSize: 'cover' } : { background: '#777777' }"></div>
        <div class="max-width" :class="{ 'all-width': isMainPage }" :style="maxWidthStyle">
          <div class="view-container" :class="{ mobile: $route.name === 'casePolicy' }" v-if="!isMainPage">
            <div class="view-field default-shadow">
              <router-view/>
            </div>
          </div>
          <div class="app-main-container" v-else>
            <component :is="'main' + $route.name" :minHeight="minHeight"></component>
          </div>
        </div>
        <layout-footer></layout-footer>
      </div>
    </div>
    <div class="modal-container">
      <modal v-if="modal.action" :style="!isDialogLoading ? {} : { display: 'none' }" :width="modal.width" :height="modal.height" :customStyles="modal.customStyles" @hide="() => {
        modal.callback && modal.callback()
        setModalAction({})
      }">
        <component :is="modal.action" :param="modal.param" @changeModal="(option, param) => {
          modal.callback && modal.callback(param)
          this.setModalAction(option || {})
        }"></component>
      </modal>
    </div>
    <layout-toast></layout-toast>
    <layoutLoading v-if="loading.value"></layoutLoading>
    <layoutUploading v-if="isUploading !== undefined" :content="isUploading"></layoutUploading>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import { getUserToken, getSource, getCountrys } from './api'
import layoutHeader from './components/layout/header'
import layoutFooter from './components/layout/footer'
import layoutToast from './components/tool/toast'
import layoutLoading from './components/layout/loading'
import layoutUploading from './components/layout/uploading'
import responsitive from './mixins/responsitive'
import toastMethods from './mixins/toastMethods'
import loginData from './mixins/loginData'
import { sortData } from './constants/global/util'
// main
import mainmain from './pages/main/main'
import mainforgot from './pages/main/forgot'
import mainreset from './pages/main/reset'
import mainredirect from './pages/main/redirect'
import mainadmin from './pages/main/admin'
import mainadminProductPrice from './pages/main/adminProductPrice'
import mainadminReport from './pages/main/adminReport'
import mainadminAccessLog from './pages/main/adminAccessLog'
import maintutorial from './pages/main/tutorial'
import mainproductPrice from './pages/main/productPrice'
import mainreport from './pages/main/report'
// modals
import modal from './components/dialog/container'
import toast from './components/dialog/toast'
import analysis from './components/dialog/analysis'
import editProductPrice from './components/dialog/editProductPrice'
import editReport from './components/dialog/editReport'
import reportDetail from './components/dialog/reportDetail'
import graphData from './components/dialog/graphData'
import batchUpload from './components/dialog/batchUpload'

import mainanalysis from './pages/main/analysis'
const mainattraction = mainanalysis
const maincompetitiveness = mainanalysis
const maintoolattraction = mainanalysis
const maintoolcompetitiveness = mainanalysis

require('font-awesome-sass-loader')

export default {
  name: 'app',
  components: {
    layoutHeader,
    layoutFooter,
    layoutToast,
    layoutLoading,
    layoutUploading,
    // main
    mainmain,
    mainforgot,
    mainreset,
    mainredirect,
    mainattraction,
    maincompetitiveness,
    maintoolattraction,
    maintoolcompetitiveness,
    mainadmin,
    mainadminProductPrice,
    mainadminReport,
    mainadminAccessLog,
    maintutorial,
    mainproductPrice,
    mainreport,
    // modals
    modal,
    toast,
    analysis,
    editProductPrice,
    editReport,
    reportDetail,
    graphData,
    batchUpload
  },
  mixins: [
    responsitive,
    loginData,
    toastMethods
  ],
  data () {
    return {
      minHeight: '300px',
      loading: {
        timer: null,
        value: false
      }
    }
  },
  watch: {
    '$route' () {
      const { body } = document
      body.scroll(0, 0)
      this.setModalAction({})
    },
    async 'isLogin' (n, o) {
      if (o !== null) {
        this.setLoadingAction(true)
        await this.preFetchDataGuest()
        if (n) {
          await this.preFetchData()
        }
        this.appInitialAction(n)
        this.setLoadingAction(false)
      }
    },
    // loading
    'isLoading' (nv) {
      if (nv) {
        this.loading.value = true
      } else {
        setTimeout(() => { this.loading.value = false }, 150)
      }
    }
  },
  computed: {
    ...mapGetters([
      'normalPage',
      'userPage',
      'adminPage',
      'isLogin',
      'isLoading',
      'isDialogLoading',
      'isUploading',
      'modal'
    ]),
    needBackground () {
      return this.$route.name && [
        'main',
        'forgot',
        'reset',
        'redirect',
        'register',
        'user',
        ''
      ].includes(this.$route.name)
    },
    isMainPage () {
      return this.$route.name && [
        'main',
        'forgot',
        'reset',
        'redirect',
        'attraction',
        'competitiveness',
        'toolattraction',
        'toolcompetitiveness',
        'admin',
        'adminProductPrice',
        'adminReport',
        'adminAccessLog',
        'report',
        'tutorial',
        'productPrice',
        ''
      ].includes(this.$route.name)
    },
    maxWidthStyle () {
      return {
        minHeight: this.minHeight,
        display: this.isMainPage ? 'flex' : 'block',
        'align-items': 'center',
        ...(this.$route.name === 'casePolicy' ? { minWidth: 0 } : {})
      }
    }
  },
  created () {
    this.setModalAction({})
    this.setLoadingAction(true)
    const validateLogin = () => {
      if (this.$route.name) {
        this.validateLogin()
      } else {
        setTimeout(() => validateLogin(), 100)
      }
    }
    validateLogin()
  },
  beforeMount () {
    const { body } = document
    const handler = () => {
      if (!document.hidden) {
        let rect = body.getBoundingClientRect()
        let headerHeight = 70
        let footerHeight = 40
        let height = rect.height - headerHeight - footerHeight + 0
        this.minHeight = height + 'px'
      }
    }
    document.addEventListener('visibilitychange', handler)
    window.addEventListener('DOMContentLoaded', handler)
    window.addEventListener('resize', handler)
  },
  methods: {
    ...mapActions([
      'appInitialAction',
      'setLoadingAction',
      'setDialogLoadingAction',
      'clearLoadingAction',
      'clearDialogLoadingAction',
      'setModalAction',
      'setSourceAction',
      'setCountrysAction'
    ]),
    async preFetchDataGuest () {
      await this.fetchSource()
    },
    async fetchSource () {
      try {
        let response = await getSource()
        let source = response.data
        this.setSourceAction(source)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async preFetchData () {
      await this.fetchCountrys()
    },
    async fetchCountrys () {
      try {
        let config = this.$ls.get('userInfo')
        let response = await getCountrys(config)
        let countrys = response.data
        countrys = sortData(Object.entries(countrys), kv => kv[1].iso_name)
        this.setCountrysAction(countrys)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
      }
    },
    async validateLogin () {
      let userInfo = this.$ls.get('userInfo') || {}
      await this.preFetchDataGuest()
      if (userInfo['access_token']) {
        await this.preFetchData()
        await this.getUserByToken(userInfo)
      } else {
        this.setUserData(null)
        this.appInitialAction(false)
        this.validateRoute(false)
      }
    },
    async getUserByToken (data) {
      try {
        let response = await getUserToken(data)
        let user = response.data.data || { role: {} }
        this.setUserData(response, data['access_token'])
        this.appInitialAction(true)
        this.validateRoute(true, null, user.role === 'admin')
      } catch (error) {
        this.setUserData(null)
        this.appInitialAction(true)
        this.addToast('error', !error.response ? error.message : error.response.data.message || error.response.data.errors.join('<br>'))
        this.validateRoute(false)
      }
    },
    validateRoute (isLogin, role, admin) {
      let array = []
      if (isLogin) {
        switch (role) {
          default: {
            array = _.union(this.userPage, this.normalPage)
          }
        }
      } else {
        array = this.normalPage
      }
      if (admin) {
        array = _.union(array, this.adminPage)
      }
      this.validateRole(isLogin, array)
    },
    validateRole (isLogin, pages) {
      let routeName = this.$route.name
      if (routeName && !_.includes(pages, routeName)) {
        this.addToast('error', isLogin ? '權限不足' : '請先登入')
        this.$router.push({ name: !isLogin ? 'main' : 'tutorial' })
        this.setLoadingAction(false)
      } else {
        if (isLogin && _.includes(this.normalPage, routeName) && routeName !== 'redirect') {
          this.$router.push({ name: 'tutorial' })
        }
        this.setLoadingAction(false)
      }
    }
  }
}
</script>

<style lang="sass">
@import sass/style
</style>



// WEBPACK FOOTER //
// src/App.vue